const BLOCKED_WORD_PATTERNS = [
    /\bf+[\W_]*u+[\W_]*c+[\W_]*k+\b/gi,
    /\bs+[\W_]*h+[\W_]*i+[\W_]*t+\b/gi,
    /\bc+[\W_]*u+[\W_]*n+[\W_]*t+\b/gi,
    /\bb+[\W_]*i+[\W_]*t+[\W_]*c+[\W_]*h+\b/gi,
    /\ba+[\W_]*s+[\W_]*s+[\W_]*h+[\W_]*o+[\W_]*l+[\W_]*e+\b/gi,
    /\bn+[\W_]*i+[\W_]*g+[\W_]*g+[\W_]*[ae]+[\W_]*r*\b/gi,
    /\bm+[\W_]*o+[\W_]*t+[\W_]*h+[\W_]*e+[\W_]*r+[\W_]*f+[\W_]*u+[\W_]*c+[\W_]*k+[\W_]*e+[\W_]*r+\b/gi,
    /\bd+[\W_]*i+[\W_]*c+[\W_]*k+\b/gi,
    /\bp+[\W_]*u+[\W_]*s+[\W_]*s+[\W_]*y+\b/gi,
    /\bw+[\W_]*h+[\W_]*o+[\W_]*r+[\W_]*e+\b/gi,
    /\bs+[\W_]*l+[\W_]*u+[\W_]*t+\b/gi,
    /\br+[\W_]*e+[\W_]*t+[\W_]*a+[\W_]*r+[\W_]*d+\b/gi,
    /\bb+[\W_]*a+[\W_]*s+[\W_]*t+[\W_]*a+[\W_]*r+[\W_]*d+\b/gi,
    /\bk+[\W_]*y+[\W_]*s+\b/gi,
    /\bkill\s+yourself\b/gi
];

export const maskBlockedLanguage = (value = '') => {
    let hadBlockedLanguage = false;
    const text = String(value || '').replace(BLOCKED_WORD_PATTERNS[0], (match) => {
        hadBlockedLanguage = true;
        return '*'.repeat([...match].length);
    });
    const filteredText = BLOCKED_WORD_PATTERNS.slice(1).reduce((current, pattern) => current.replace(pattern, (match) => {
        hadBlockedLanguage = true;
        return '*'.repeat([...match].length);
    }), text);

    return { text: filteredText, hadBlockedLanguage };
};

const warnAboutBlockedLanguage = () => {
    window.dispatchEvent(new CustomEvent('jumptake-content-warning', {
        detail: {
            message: 'Inappropriate language was replaced. Please keep your content professional and review the Terms and Conditions.'
        }
    }));
};

export const installContentSafetyTypingGuard = () => {
    if (typeof window === 'undefined' || window.__jumptakeContentSafetyGuardInstalled) return;
    window.__jumptakeContentSafetyGuardInstalled = true;

    document.addEventListener('input', (event) => {
        const field = event.target;
        if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
        if (field.dataset.contentSafety === 'off') return;
        if (field instanceof HTMLInputElement && ['checkbox', 'radio', 'file', 'hidden', 'password', 'email', 'url', 'number', 'date', 'time'].includes(field.type)) return;

        const value = field.value;
        const filtered = maskBlockedLanguage(value);
        if (!filtered.hadBlockedLanguage) return;

        const start = field.selectionStart;
        const end = field.selectionEnd;
        field.value = filtered.text;
        if (typeof start === 'number' && typeof end === 'number') {
            field.setSelectionRange(start, end);
        }
        warnAboutBlockedLanguage();
    }, true);
};
